<template>
  <b-row id="companies-block" class="section-invert">
    <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto">
      </div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto">
      <h3>{{ $t('openlegal.title') }}</h3>
      <div class="subtitle">
        <p>{{ $t('openlegal.subtitle') }}</p>
        <div class="subtitle-list mt-5">
           <b-row>
             <b-col cols="12">
               · {{ $t('openlegal.video-chat-service')}}
              </b-col>
              <br><br>
             <b-col cols="12">
               · {{ $t('openlegal.legal-documentation')}}
             </b-col>
           </b-row>
           <b-row class="mt-5">
              <base-button white outline @click="$helpers.goToSection('contact-form')">{{ $t('more-info') }}</base-button>
            </b-row>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

let messages = {
  es: {
    'openlegal': {
      'title': 'openlegal para empresas',
      'subtitle': 'El servicio legal que pone a disposición de tus clientes, empleados o asegurados, los servicios de un abogado en cualquier momento y desde cualquier lugar.',
      'video-chat-service': 'Servicio de Video, teléfono y Chat disponible 365 días, para resolver consultas legales.',
      'legal-documentation': 'Permite el envío de documentación legal para un mejor asesoramiento: multa, sanción, contrato, citación del Juzgado, demanda, denuncia...'
    }
  },
  en: {
    'openlegal': {
      'title': 'openlegal for companies',
      'subtitle': 'The legal service that puts at your disposal of your clients, employees or insureds, the legal services of a lawyer at any time and from any place.',
      'video-chat-service': 'Video, phone and chat service available 365 days, to resolve legal questions.',
      'legal-documentation': 'Allows the sending of legal documentation for a better assistance: fine, punishment, contract, court order, demand, complaint...'
    }
  },
  pt: {
    'openlegal': {
      'title': 'openlegal para empresas',
      'subtitle': 'O serviço legal que disponibiliza aos seus clientes, empregados ou segurados, os serviços de um advogado em qualquer momento e desde qualquer lugar.',
      'video-chat-service': 'Serviço de Video e Chat disponível 365 dias, para resolver consultas legais.',
      'legal-documentation': 'Permite o envio de documentação legal para um melhor atendimento: multa, punição, contrato, ordem do Juízo, demanda, denúncia...'
    }
  }
}

messages.mx = messages.es

export default {
  i18n: {
    messages
  }
}
</script>

<style lang="scss">
  #companies-block {
    .col-bg {
      background-blend-mode: overlay;
      background-position: bottom;
      background-image: url('/static-appopensalud/img/bgs/openlegal/bg3.jpeg'), linear-gradient(to bottom, $body-bg, transparent), linear-gradient(to top, transparent, $body-bg);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/OpenlegalForCompanies.vue